<!--单选 SCQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{ `${index + 1}、` }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>单选</p>
          </div>
        </div>
        <div class="question-header-right">
          <div
            v-if="type === 1"
            class="question-logic"
            @click.stop="handleLogicClick"
          >
            <img
              src="@/assets/images/questionnaire/jiaohuan_D_01.png"
              mode="widthFix"
              style="width: 17px; margin-left: 3px"
            />
            <p>逻辑设置</p>
          </div>
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
        :style="{
          border:
            isFocusIndex === '-1'
              ? '1px solid rgba(58,96,255,0.5)'
              : '1px solid #DCDDE0',
        }"
      >
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请选择一个选项"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
      <div class="options">
        <div v-for="(option, index) in list" :key="index">
          <div class="option-item">
            <div class="option-item-top">
              <div class="option-item-top-left">
                <img
                  v-if="list.length > 2"
                  @click="delItem(index)"
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                />
                <img
                  v-else
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
                />
              </div>
              <div
                class="option-item-top-right"
                :style="{
                  border:
                    inputFocusIndex === `a${index}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <div class="option-item-top-right-up">
                  <input
                    placeholder-class="input-placeholder"
                    type="text"
                    :placeholder="'选项' + (index + 1)"
                    v-model="option.text"
                    @input="handleInput"
                    @focus="inputFocusIndex = 'a' + index"
                    @blur="inputFocusIndex = ''"
                  />
                  <div class="option-item-top-right-right">
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
                      mode=""
                      style="
                        width: 18px;
                        height: 18px;
                        margin-right: 6px;
                        cursor: pointer;
                      "
                      @click="handleItemImage(index)"
                    />
                    <el-checkbox
                      label="填空"
                      v-model="option.is_fill"
                      :true-label="1"
                      :false-label="0"
                      @click.stop=""
                      class="custom-checkbox"
                    ></el-checkbox>
                  </div>
                </div>

                <div class="question-images">
                  <div
                    class="question-images-box"
                    @click.stop="showBigImage(imgItem, option)"
                    v-for="(imgItem, imgIndex) in option.img_path"
                    :key="index"
                    style="
                      margin-top: 10px;
                      position: relative;
                      margin-bottom: 5px;
                    "
                  >
                    <img
                      :src="imgItem"
                      mode="aspectFill"
                      class="thumbnail-image"
                    />
                    <div class="fangda-box">
                      查看图片
                      <!-- <img src="../../static/image/searchWhite.png" mode="" class="fangda"> -->
                    </div>
                    <img
                      src="@/assets/images/guanbi.png"
                      mode="widthFix"
                      class="guanbi"
                      @click="handleDeleteItemImage(index, imgIndex)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="option.is_fill" class="option-item-bottom">
              <div
                class="option-item-bottom-input"
                :style="{
                  border:
                    inputFocusIndex === `b${index}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <input
                  placeholder-class="input-placeholder"
                  type="text"
                  placeholder="编辑提示词"
                  v-model="option.fill_prompt"
                  @input="handlePromptInput"
                  @focus="inputFocusIndex = `b${index}`"
                  @blur="inputFocusIndex = ''"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="add-view">
        <div class="add-batch" style="color: #ffffff">
          <el-checkbox
            label="必选题"
            v-model="isMust"
            :true-label="1"
            :false-label="0"
            class="custom-checkbox"
            @change="handleCheckboxChange"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            mode=""
            style="width: 13px; height: 13px"
          />
          <p>添加选项 {{ list.length + "/50" }}</p>
        </div>
        <div @click="batchAddOptions" class="add-batch">批量添加</div>
      </div>
    </div>
    <div v-if="type === 1" class="option-settings">
      <p></p>
      <el-checkbox
        label="选项随机排列"
        v-model="ifRandomize"
        style="transform: scale(1.0)"
      ></el-checkbox>
    </div>

    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <PopupInput
      :showDialog="showpopup"
      :title="'批量添加'"
      :aContent="''"
      :type="1"
      @close="showpopup = false"
      @confirm="bitchConfirm"
    ></PopupInput>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
    <div class="coverShow" v-show="logicShow">
      <div class="container-gj">
        <div class="container-gd">
          <div class="header-div">
            <div
              style="
                font-size: 18px;
                font-weight: 600;
                color: #2b2f36;
                line-height: 24px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
            >
              逻辑设置
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              mode=""
              @click="logicShow = false"
              style="
                width: 13px;
                height: 13px;
                position: absolute;
                right: 20px;
                cursor: pointer;
              "
            />
          </div>
          <div v-if="target === 0" class="logic-container">
            <div
              v-for="(item, index) in list"
              :key="index"
              style="
                border-bottom: 1px solid #f0f0f0;
                padding: 15px 10px;
                box-sizing: border-box;
              "
            >
              <div class="left-item" @click.stop="selectOption(item, index)">
                <div class="left-item-title">{{ item.text }}</div>
                <div class="left-item-desc">
                  <p>设置</p>
                  <i class="el-icon-arrow-right" size="14" color="#3a60ff"></i>
                </div>
              </div>
              <div
                v-if="
                  item.jump_title !== '' &&
                    item.jump_title !== undefined &&
                    item.jump_title !== null
                "
                style="
                  margin-top: 10px;
                  border: 1px solid #dddddd;
                  border-radius: 5px;
                  background-color: #f9f9f9;
                  font-size: 15px;
                  color: #4c4a56;
                  width: 200px;
                  height: 37px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 0 10px;
                  box-sizing: border-box;
                "
              >
                <p>{{ item.jump_title }}</p>
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
                  @click="deleteClick(item, index)"
                  mode=")"
                  style="width: 13px; height: 13px; cursor: pointer"
                />
              </div>
            </div>
          </div>
          <div v-else class="logic-container">
            <div
              v-for="(item, index) in questionList"
              :key="index"
              class="choose-css"
              :style="{
                border:
                  selectIndex === index
                    ? `1px solid rgba(58,96,255,0.5)`
                    : '1px solid rgba(237,237,237,0.5)',
                background:
                  selectIndex === index
                    ? 'rgba(58,96,255,0.1)'
                    : 'rgba(247,247,247,1)',
                fontWeight: selectIndex === index ? 'bold' : 'normal',
              }"
              @click="selectQuestion(item, index)"
            >
              <p
                style="white-space: normal; word-break: break-all"
                :style="{
                  color:
                    selectIndex === index
                      ? 'rgba(58,96,255,1)'
                      : 'rgba(43,47,54,1)',
                }"
              >
                {{ item.sort + "、" + item.caseProblem }}
              </p>
              <div style="display: flex; align-items: center">
                <img
                  :src="
                    selectIndex === index
                      ? 'https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg'
                      : 'https://ossfastmake.mustke.com/qrCode/tupian/1747892286609.svg'
                  "
                  alt=""
                  srcset=""
                  style="width: 15px; height: 15px"
                />
              </div>
            </div>
            <div
              class="choose-css"
              :style="{
                border:
                  selectIndex === questionList.length
                    ? `1px solid rgba(58,96,255,0.5)`
                    : '1px solid rgba(237,237,237,0.5)',
                background:
                  selectIndex === questionList.length
                    ? 'rgba(58,96,255,0.1)'
                    : 'rgba(247,247,247,1)',
                fontWeight:
                  selectIndex === questionList.length ? 'bold' : 'normal',
              }"
              @click="endClick"
            >
              <p
                style="white-space: normal; word-break: break-all"
                :style="{
                  color:
                    selectIndex === questionList.length
                      ? 'rgba(58,96,255,1)'
                      : 'rgba(43,47,54,1)',
                }"
              >
                {{ "问卷结尾，结束答题" }}
              </p>
              <div style="display: flex; align-items: center">
                <img
                  :src="
                    selectIndex === questionList.length
                      ? 'https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg'
                      : 'https://ossfastmake.mustke.com/qrCode/tupian/1747892286609.svg'
                  "
                  alt=""
                  srcset=""
                  style="width: 15px; height: 15px"
                />
              </div>
            </div>
          </div>
          <div style="width: 100%; display: flex; justify-content: center">
            <!-- <el-button
              @click="cancelClick"
              style="width: 120px; margin: 20px auto"
              >取消</el-button
            > -->
            <el-button
              type="primary"
              @click="confirmClick"
              style="width: 120px; margin: 20px auto"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  components: {
    PopupInput,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    // uuid: {
    //   type: String,
    //   default: "",
    // },
    uuid: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
    allDatas: {
      type: Array,
      // default: [],
      default: () => [],
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      showpopup: false,
      showUpload: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      logicShow: false,
      rules: [],
      target: 0,
      questionList: [],
      selectIndex: 0,
      selectOptionIndex: 0,
      selectOptionItem: {},
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
          this.handleUpdateQuestion();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        })
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    handlePromptInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          id: "", //后台处理逻辑 创建时不传 唯一标识用
          text: "",
          isChoose: false,
          img_path: [],
          is_fill: 0, //是否填空 0否 1是
          fill_prompt: "",
          jump_title: "",
        });
        this.handleUpdateQuestion();
      } else {
        uni.showToast({
          title: "最多只能添加50个选项",
          icon: "none",
        });
      }
    },

    batchAddOptions() {
      // 批量添加选项的逻辑
      this.showpopup = true;
    },
    bitchConfirm(e) {
      // 批量添加选项的逻辑
      this.showpopup = false;
      const count = e.split("\n").filter((item) => item.trim() !== "").length;
      if (count > 50 - this.list.length) {
        uni.showToast({
          title: "最多只能添加50个选项",
          icon: "none",
        });
        return;
      }
      const list = e
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item) => {
          return {
            id: "", //后台处理逻辑 创建时不传 唯一标识用
            text: item,
            isChoose: false,
            img_path: [],
            is_fill: 0, //是否填空 0否 1是
            fill_prompt: "",
            newDate: true,
          };
        });
      this.list = this.list.concat(list);
      this.handleUpdateQuestion();
    },
    delItem(index) {
      if (this.updateType === 1) {
        if (this.list[index].newDate) {
          this.list.splice(index, 1);
          this.handleUpdateQuestion();
        } else {
          uni.showToast({
            title: "限制性修改状态下，不能删除之前的数据!",
            icon: "none",
          });
        }
      } else {
        this.list.splice(index, 1);
        this.handleUpdateQuestion();
      }
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleItemImage(index) {
      this.uploadIndex = index;
      this.$refs.fileInput.click();
    },

    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleDeleteItemImage(index, imgIndex) {
      this.list[index].img_path.splice(imgIndex, 1);
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          return item;
        }),
      });
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        uni.showToast({
          title: "请输入题目",
          icon: "none",
        });
      }

      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "请选择一个选项" : this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          item.text = item.text === "" ? `选项${index + 1}` : item.text;
          return item;
        }),
      });
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    handleClick() {},
    handleLogicClick() {
      if (this.dataObj.id) {
        // 逻辑设置的逻辑
        this.logicShow = true;
      } else {
        // 先保存
        this.$message.error("请先保存题目");
      }
    },
    selectQuestion(item, index) {
      this.selectQuestionItem = item;
      this.selectQuestionIndex = index;
      this.selectIndex = index;
      this.action = "jump";
    },
    endClick() {
      this.action = "end";
      this.selectIndex = this.questionList.length;
    },
    selectOption(item, index) {
      console.log("selectOption", this.rules, this.list, item, index);
      this.selectOptionItem = item;
      this.selectOptionIndex = index;

      if (this.rules[index].action === "end") {
        this.selectIndex = this.questionList.length;
      } else {
        this.selectIndex = this.questionList.findIndex((item) => {
          return item.sort === this.rules[index].targets[0];
        });
      }
      this.target = 1;
    },
    cancelClick() {
      if (this.target === 0) {
        emit("close");
      } else {
        this.target = 0;
      }
    },
    confirmClick() {
      console.log(
        "confirmClick",
        this.selectQuestionItem,
        this.selectQuestionIndex,
        this.selectOptionItem,
        this.selectOptionIndex
      );
      if (this.target === 0) {
        // let data = this.list[this.index];
        // data.chooseList = JSON.stringify({
        //   list: this.list,
        // });
        // const isEmpty = this.rules.every((item) => {
        //   return (
        //     item.targets.length === 0 &&
        //     item.when.length === 0 &&
        //     item.action === ""
        //   );
        // });
        // if (!isEmpty) {
        //   data.logicalJump = JSON.stringify({
        //     rules: this.rules,
        //   });
        // }
        // emit("close");
        // emit("confirm", data);
        this.logicShow = false;
      } else {
        if (this.action === "end") {
          this.rules[this.selectOptionIndex].when = [this.selectOptionItem.id];
          this.rules[this.selectOptionIndex].targets = [];
          this.rules[this.selectOptionIndex].action = this.action;
          this.list[this.selectOptionIndex].jump_title = "问卷结尾，结束答题";
          // this.rules[this.selectOptionIndex].problem = "问卷结尾，结束答题";
        } else {
          this.rules[this.selectOptionIndex].when = [this.selectOptionItem.id];
          this.rules[this.selectOptionIndex].targets = [
            this.selectQuestionItem.sort,
          ];
          this.rules[this.selectOptionIndex].action = this.action;
          // this.list[this.selectOptionIndex].jump_title = this.selectQuestionItem.caseProblem;
          this.list[
            this.selectOptionIndex
          ].jump_title = `跳转到 第${this.selectQuestionItem.sort}题`;
          this.rules[
            this.selectOptionIndex
          ].problem = this.selectQuestionItem.caseProblem;
        }
        this.target = 0;
      }
      console.log("confirmClick", this.rules, this.list);
    },
    deleteClick(item, index) {
      console.log("deleteClick", item, index);
      this.$confirm("确认删除此逻辑？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.list[index].jump_title = "";
        this.rules[index].when = [];
        this.rules[index].targets = [];
        this.rules[index].action = "";
        console.log("哈哈哈哈哈哈哈哈", this.list, this.rules);
      });
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.list = JSON.parse(newVal.chooseList).list.map((item) => {
          item.is_fill = item.is_fill === 1;
          return item;
        });
        this.ifRandomize = newVal.ifRandomize === 1;
        this.isMust = newVal.isMust === 1;
        this.images = JSON.parse(newVal.caseProblemImg);

        this.rules = [];
        if (
          newVal.logicalJump !== "" &&
          newVal.logicalJump !== null &&
          newVal.logicalJump !== undefined
        ) {
          const jumpData = JSON.parse(data.logicalJump);
          this.rules = jumpData.rules;
        } else {
          for (let i = 0; i < this.list.length; i++) {
            this.rules.push({
              when: [], //暂时没用 但是不能没有
              action: "", //jump 跳转 end 结束
              targets: [], //里面的值是/** 排序字段 */sort
            });
          }
        }
      },
      deep: true,
      immediate: true,
    },
    allDatas: {
      handler(newVal, oldVal) {
        console.log("list 变化了", newVal, oldVal);
        this.questionList = newVal.filter((item, index) => {
          return (
            index > this.index &&
            (item.logicalJump === "" ||
              item.logicalJump === null ||
              item.logicalJump === undefined)
          );
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}
.textarea-box textarea {
  color: #4c4a56;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1010;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 1010;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 1010;
  transform: translate(-50%, -50%);
  overflow: hidden;
  overflow-y: auto;
}

.header-div {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
}

.logic-container {
  width: 100%;
  height: 300px;
  overflow: hidden;
  overflow-y: auto;
  padding: 0 10px;
  box-sizing: border-box;
}

.left-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-item-title {
  font-size: 15px;
  font-weight: 500;
  color: #4c4a56;
  max-width: 150px;
  overflow: hidden;
}

.left-item-desc {
  font-size: 14px;
  font-weight: 400;
  color: #3a60ff;
  display: flex;
  align-items: center;
  flex-grow: 1;
  text-align: right;
  justify-content: flex-end;
  margin-left: 15px;
  cursor: pointer;
}

.question-logic {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #2b2f36;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditSCQ.vue